<div>
	<cdk-table-component
		[displayColumns]="displayColumns"
		[entities]="tableEntities"
		[dataSource]="dataSource"
		(rowClickAction)="viewEntry($event)"
		[footer]="footer"
	></cdk-table-component>
</div>
